import flightsService from "../api/server/flightsService";
export const FLIGHTS_NAMESPACE = "flightsModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/flightsService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(flightsService)
};

const state = {
  loading: false,
  flightAlerts: [],
  divertedFlightAlerts: [],
  hoursPast: "6",
  divertedHoursPast: "10"
};
const actions = {
  async loadFlightAlerts(context) {
    context.commit("SET_FLIGHT_ALERTS_LIST", []);
    context.state.loading = true;
    var api = await services.api;
    return api.loadFlightAlerts(context.state.hoursPast).then(response => {
      context.commit("SET_FLIGHT_ALERTS_LIST", response);
      context.state.loading = false;
    });
  },
  async loadDivertedFlightAlerts(context) {
    context.commit("SET_DIVERTED_FLIGHT_ALERTS_LIST", []);
    context.state.loading = true;
    var api = await services.api;
    return api
      .loadDivertedFlightAlerts(context.state.divertedHoursPast)
      .then(response => {
        context.commit("SET_DIVERTED_FLIGHT_ALERTS_LIST", response);
        context.state.loading = false;
      });
  },
  setHoursPast(context, data) {
    return context.commit("SET_FLIGHT_HOURS_PAST", data);
  },
  setDivertedHoursPast(context, data) {
    return context.commit("SET_FLIGHT_DIVERTED_HOURS_PAST", data);
  }
};

const mutations = {
  SET_DIVERTED_FLIGHT_ALERTS_LIST(storeState, data) {
    storeState.divertedFlightAlerts = data;
  },
  SET_FLIGHT_ALERTS_LIST(storeState, data) {
    storeState.flightAlerts = data;
  },
  SET_FLIGHT_HOURS_PAST(storeState, data) {
    storeState.hoursPast = data;
  },
  SET_FLIGHT_DIVERTED_HOURS_PAST(storeState, data) {
    storeState.divertedHoursPast = data;
  }
};

const getters = {
  loading: storeState => storeState.loading,
  flightAlerts: storeState => storeState.flightAlerts,
  divertedFlightAlerts: storeState => storeState.divertedFlightAlerts,
  hoursPast: storeState => storeState.hoursPast,
  divertedHoursPast: storeState => storeState.divertedHoursPast
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
